/**
 * Returns shipment map
 * @param {Object} state the redux store
 * @return {Object} id -> shipment
 */
export const getShipments = state => state.entities.shipmentsV2.entities;
